import React, { ReactElement } from 'react';

import styles from './ImageDescription.module.scss';
import { IImage } from "@common/redux/types/images";
import { isValidUrl } from "@common/utils/isValidUrl";

interface IProps {
  image: IImage;
}

export const ImageDescription = ({ image }: IProps): ReactElement => {
  if (image) {
    return (
      <div className={styles.wrapper}>
        {isValidUrl(image.url) && (
          <a className={styles.link} href={image.url} target="_blank" rel="noreferrer">{image.sourceTitle}</a>
        )}
        {!isValidUrl(image.url) && (
          <div className={styles.sourceTitle}>{`${image.url} / ${image.sourceTitle}`}</div>
        )}
        {image.description && (
          <div className={styles.description}>{image.description}</div>
        )}
      </div>
    );
  }
};
